import z from "zod";

export const ResetPasswordVerificationSchema = z.object({
  code: z.string().min(1, "Code is required"),
  password: z
    .string()
    .min(1, "Password is required")
    .min(8, "Password must be at least 8 characters")
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    ),
});

export type ResetPasswordVerificationFormValues = z.infer<
  typeof ResetPasswordVerificationSchema
>;
